import axios from 'axios';
import get from 'lodash/get';

const notify = (text, icon = 'mdi-check', color = 'info') => {
    window.EventBus.$emit('notify', {
        message: { icon, text },
        color,
    });
};

const handleMetadata = (metadata) => {
    if (metadata?.toasts && Array.isArray(metadata?.toasts)) {
        for (let toast of metadata?.toasts) {
            notify(toast.text, toast.icon, toast.color);
        }
    }
};

axios.interceptors.response.use(
    (response) => {
        handleMetadata(response?.data?.metadata);
        return response;
    },
    async (error) => {
        const status = get(error, 'response.status');

        if (status === 419) {
            // Refresh our session token
            await axios.get('/csrf-token');

            // Return a new request using the original request's configuration
            return axios(error.response.config);
        }

        handleMetadata(error?.response?.data?.metadata);
        throw error;
    }
);

export { axios };
